import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import { hasPermission } from 'config/roles';
import { validateToken } from '../data/authentification';
import { setCredentials, logout } from '../providers/AuthContext';
import { useEffect, useState } from 'react';

const ProtectedChildren = ({ children, path: parentPath }) => {
  const dispatch = useDispatch();

  const { isAuthenticated, user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(true);
  console.log('user:', user);
  useEffect(() => {
    const validateTokenCheck = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken && !isAuthenticated) {
        try {
          const response = await validateToken(storedToken);

          if (response.valid) {
            dispatch(
              setCredentials({
                token: storedToken,
                user: response.user,
                id: response.user.id,
                routes: response.routes,
              })
            );
          } else {
            dispatch(logout());
          }
        } catch (error) {
          dispatch(logout());
        }
      }
      setLoading(false);
    };

    validateTokenCheck();
  }, [dispatch, isAuthenticated]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/authentication/card/login" replace />;
  }

  if (user?.role === 'admin') {
    return children;
  }

  if (!parentPath) {
    return <Navigate to="/errors/404" replace />;
  }

  // Check if the current path is a child of the parent path
  // const isChildPath = location.pathname.startsWith(parentPath);

  // if (isChildPath && !hasPermission(role, parentPath)) {
  //   return <Navigate to="/error/403" replace />;
  // }

  return children;
};

export default ProtectedChildren;
